import { AppShell } from "./components/AppShell";
import { LoginScreen } from "./components/LoginScreen";
import { AppProvider, useApp } from "./state/AppContext";

function AppSurface() {
  const { session } = useApp();
  return session ? <AppShell /> : <LoginScreen />;
}

export default function App() {
  return (
    <AppProvider>
      <AppSurface />
    </AppProvider>
  );
}
